import { inject, observer } from 'mobx-react'
import { withRouter } from 'next/router'
import PropTypes from 'prop-types'
import TimelineSlider from '../components/TimelineSlider'

import { Component } from 'react'
import Footer from '../components/Footer'
import HeadlinersRoundGrid from '../components/HeadlinersRoundGrid'
import Layout from '../components/Layout'
import PostGrid from '../components/PostGrid'
import historyData from '../constants/history'
import { withTranslation } from '../i18n'
import { HistoryContent } from '../styles/newsStyles.ts'

@inject('store')
@observer
class History extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    i18n: PropTypes.instanceOf(Object).isRequired,
    store: PropTypes.instanceOf(Object).isRequired,
    router: PropTypes.instanceOf(Object).isRequired
  }

  static getInitialProps() {
    return {
      namespacesRequired: [
        'news',
        'common',
        'magazine',
        'auth',
        'reset-password',
        'contacts'
      ]
    }
  }

  componentDidMount() {
    this.getData()
  }

  getData() {
    const {
      i18n: { language },
      store
    } = this.props
    store.loadHeadliners(language)
  }

  render() {
    const {
      t,
      i18n: { language },
      router: {
        query: { year }
      },
      store
    } = this.props

    let activeYear = +year
    activeYear =
      Number.isNaN(activeYear) || activeYear < 2015 || activeYear > 2023
        ? 2023
        : activeYear
    const showNews = activeYear === 2022


    const yearsInfo = [
      {
        currentYear: 2015,
        guests: `70${language === 'en' ? '\u00A0000' : ''}\u00A0${t('guests')}`,
        stages: `43\u00A0${t('venues2')}`,
        artists: `1000\u00A0${t('musicians')}`
      },
      {
        currentYear: 2016,
        guests: `120${language === 'en' ? '\u00A0000' : ''}\u00A0${t(
          'guests'
        )}`,
        stages: `76\u00A0${t('venues1')}`,
        artists: `1500\u00A0${t('musicians')}`
      },
      {
        currentYear: 2017,
        guests: `150${language === 'en' ? '\u00A0000' : ''}\u00A0${t(
          'guests'
        )}`,
        stages: `100\u00A0${t('venues1')}`,
        artists: `1500\u00A0${t('musicians')}`
      },
      {
        currentYear: 2018,
        guests: `200${language === 'en' ? '\u00A0000' : ''}\u00A0${t(
          'guests'
        )}`,
        stages: `103\u00A0${t('venues2')}`,
        artists: `2000\u00A0${t('musicians')}`
      },
      {
        currentYear: 2019,
        guests: `300${language === 'en' ? '\u00A0000' : ''}\u00A0${t(
          'guests'
        )}`,
        stages: `80\u00A0${t('venues1')}`,
        artists: `2500\u00A0${t('musicians')}`
      },
      {
        currentYear: 2020,
        guests: `170${language === 'en' ? '\u00A0000' : ''}\u00A0${t(
          'guests'
        )}`,
        stages: `50\u00A0${t('venues1')}`,
        artists: `700\u00A0${t('musicians')}`
      },
      {
        currentYear: 2021,
        guests: `50${language === 'en' ? '\u00A0000' : ''}\u00A0${t('guests')}`,
        stages: `52\u00A0${t('venues1')}`,
        artists: `1300\u00A0${t('musicians')}`,
        additionalInfo: [t('covid-free')]
      },
      {
        currentYear: 2022,
        guests: `360${language === 'en' ? '\u00A0000' : ''}\u00A0${t('guests')}`,
        stages: `103\u00A0${t('venues2')}`,
        artists: `3000\u00A0${t('musicians')}`
      },
      {
        currentYear: 2023,
        guests: `370${language === 'en' ? '\u00A0000' : ''}\u00A0${t('guests')}`,
        stages: `102\u00A0${t('venues2')}`,
        artists: `3000\u00A0${t('musicians')}`
      }
    ]

    return (
      <Layout
        meta={{ title: t('common:PAGE_NEWS_TITLE') }}
        coverImageUrl="news-cover"
      >
        <TimelineSlider activeYear={activeYear} yearsInfo={yearsInfo} />

        <HistoryContent className="content">
          {historyData[activeYear].video && (
            <div className="videoBlock" key={activeYear}>
              <video
                poster="" // don't delete this line!
                autoPlay
                muted
                loop
                playsInline
              >
                <source
                  src={`/static/videos/${historyData[activeYear].video}.webm`}
                  type="video/webm"
                />
                <source
                  src={`/static/videos/${historyData[activeYear].video}.mp4`}
                  type="video/mp4"
                />
              </video>
            </div>
          )}
          <h1>{`Ural Music Night ${activeYear}`}</h1>
          {/* <p dangerouslySetInnerHTML={{ __html: t(`year${activeYear}`) }} /> */}
          <p>{t(`year${activeYear}`)}</p>
          {store.headliners.has(activeYear) && (
            <HeadlinersRoundGrid
              headliners={store.headliners.get(activeYear)}
              activeYear={activeYear}
            />
          )}
          {showNews && <PostGrid categories={['umn-news']} />}
        </HistoryContent>
        <Footer />
      </Layout>
    )
  }
}

const HistoryRouter = withRouter(History)
export default withTranslation([
  'news',
  'common',
  'magazine',
  'auth',
  'reset-password',
  'contacts'
])(HistoryRouter)
